import { ICardDetailReport } from "./CardDetailReportInterfaces";
import CloseIcon from "@mui/icons-material/Close";
import { useStyles } from "./CardDetailReport.styles";

const CardDetailReport = ({ children, onClose, title }: ICardDetailReport) => {
    const classes = useStyles();
    return (
        <div className={classes.downtimeSummaryWrapper}>
            <div className={classes.card}>
                <div className={classes.cardHeader}>
                    <div className={classes.cardTitle}>{title}</div>
                    <CloseIcon className={classes.closeIcon} onClick={onClose} />
                </div>
                {children}
            </div>
        </div>
    );
};

export default CardDetailReport;
